export const notificationBadgeKey = 'notifications';

export const navigation = [
  {
    text: 'Dashboard',
    icon: 'datatrending',
    path: '/dashboard',
    hint: 'Dashboard',
  },
  {
    text: 'Tasks',
    icon: 'checklist',
    path: '/tasks',
    hint: 'Tasks',
  }
  /*,
  {
    text: 'Configuration',
    icon: 'preferences',
    items: [
      {
        text: 'Generate Tasks',
        path: '/configuration/generatetasks'
      }
    ]
  }*/
  ,
  {
    text: 'Notifications',
    path: '/notifications',
    icon: 'bell',
    hint: 'Notifications',
    showBadge: true,
    badge: notificationBadgeKey
  }/*,
      {
    text: 'Sandbox',
    icon: 'datatrending',
    path: '/sandbox',
    hint: 'Sandbox',
  },*/
];


